import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowClockwiseOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowClockwiseOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M19 13.75c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7h1.04l-2.55 3.5h2.47l3.27-4.5-3.27-4.5h-2.47l2.55 3.5H12c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9h-2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowClockwiseOutlined;